import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=logged in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (data && data.needs_2fa) {
      // caller must complete 2FA step; do NOT set user yet
      return { needs_2fa: true, pending_token: data.pending_token, username: data.username };
    }
    setUser(data);
    return data;
  };

  const login2fa = async (pending_token, code) => {
    const { data } = await api.post("/auth/login/2fa", { pending_token, code });
    setUser(data);
    return data;
  };

  const register = async (username, password, email) => {
    const { data } = await api.post("/auth/register", { username, password, email });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_err) {
      /* logout best-effort */
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, login2fa, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { formatApiErrorDetail };
